/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IGeneralInformation } from 'base/auth/interface';
import { EditProfileState } from './interface';

export const initialState: EditProfileState = {
  stateLoading: false,
  loading: false,
};

export const updateProfiletSlice = createSlice({
  name: 'feature/profile/edit-profile',
  initialState,
  reducers: {
    updateProfile(state: EditProfileState, _action: PayloadAction<IGeneralInformation>) {
      state.loading = true;
    },
    updateProfileFailed(state: EditProfileState) {
      state.loading = false;
    },
  },
});

export const { actions: editProfileActions } = updateProfiletSlice;
